import styled from "styled-components";
import { getMarginX, getMarginY } from "../utils";

interface StyledIndicationProps {
  thumbSize: number;
  trackHeight: number;
}

export default styled.h6<StyledIndicationProps>`
  padding: 0;
  margin: 0;
  color: #ffffff;
  font-size: 24px;
  font-weight: 300;

  position: absolute;
  top: ${({ thumbSize, trackHeight }) =>
    getMarginY(thumbSize, trackHeight) - 10}px;
  right: -${({ thumbSize }) => getMarginX(thumbSize) + 20}px;
`;
